import { gql, TypedDocumentNode } from "@apollo/client";
import { MEMBERSHIP_BAND_FRAGMENT } from "@/fragments";

export type UpdateMembershipInput = {
  personId: string;
  classificationId: string;
  sectionId: string;
  startedOn: string;
  note?: string | null;
};

export const UPDATE_MEMBERSHIP_MUTATION: TypedDocumentNode<
  {
    updateMembership: {
      success: boolean;
      message: string;
      band?: {
        id: string;
        person: {
          id: string;
          bands: Array<{
            id: string;
          }>;
        };
      };
    };
  },
  { input: UpdateMembershipInput }
> = gql`
  mutation UpdateMembership($input: BackofficeUpdateMembershipInput!) {
    updateMembership(input: $input) {
      success
      message
      band {
        id
        person {
          id
          bands {
            id
            ...MembershipBandFragment
          }
        }
      }
    }
  }
  ${MEMBERSHIP_BAND_FRAGMENT}
`;
